import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MessageDialogComponent } from '../message-dialog/message-dialog.component';
import { APIOperationResult } from '../_models/apioperation-result';
import { ResetPasswordArgs } from '../_models/reset-password-args';
import { UserAccountService } from '../_services/user-account.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  public resetPasswordArgs: ResetPasswordArgs = new ResetPasswordArgs();

  public passwordResetForm: FormGroup;

  constructor(
    public formBuilder: FormBuilder,
    public usersService: UserAccountService,
    public dialog: MatDialog,
    public router: Router
  )
  {
    this.passwordResetForm = this.formBuilder.group({
      'emailAddress': [this.resetPasswordArgs.emailAddress, []]
    });
  }

  ngOnInit(): void {
  }

  onSubmit() {
    var resetArgs = <ResetPasswordArgs>this.passwordResetForm.value;

    this.usersService.resetPasssword(resetArgs).then((result: APIOperationResult) => {

      //If we had a success message, display the confirmation dialog, which talks about how
      this.dialog.open(MessageDialogComponent, {
        data: {
          title: "Password Reset",
          message: "If the user account attached to the given email exists, the password has been reset and a message dispatched to that email address with further instructions."
        }
      }).afterClosed().subscribe(() => {
        //Navigate back to the login page.
        this.router.navigate(['/login']);
      });
    },
    (err) => {
    });
  }
}
